// extracted by mini-css-extract-plugin
export default {"box":"Box_box__XKd6n","L":"Box_L__nfC2Z","M":"Box_M__Q8zrc"};